export default __webpack_public_path__ + "static/media/title-descriptionInfo.1668a3e5.png";